/* eslint-disable react/require-default-props */
// eslint-disable-next-line no-use-before-define
import React, { useState } from 'react';
import { useHistory } from 'react-router-dom';
import {
  Paper, Box, Typography,
  Grid, Link, Stack, Select,
  MenuItem, IconButton, Table, TableBody, TableCell, TableContainer, TableHead, TableRow,
} from '@mui/material';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import HistoryIcon from '@mui/icons-material/History';
import { ReactElementLike } from 'prop-types';
import { colors } from '../../services/colors';

type _BackTitle = {
    title: string;
    icon?: ReactElementLike;
}
export default function BackTitle({ title, icon }: _BackTitle) {
  const history = useHistory();
  return (
    <>
      <Box sx={{ display: 'flex', width: '100%' }}>
        {' '}
        <IconButton onClick={() => history.goBack()} sx={{ marginTop: '-8px' }}>
          <ArrowBackIcon sx={{ color: colors.themePrimary, fontSize: '30px' }} />
        </IconButton>
        <Typography variant="h5" align="right" sx={{ position: 'relative', marginLeft: 'auto' }}>
          { title }
        </Typography>
        { icon }
      </Box>
    </>
  );
}
